import React, { useEffect, useState } from "react";
import api from "../utils/api";

/**
 * PartnerSpot – zeigt aktive Partner-Banner für eine bestimmte Position.
 * Klassen-/ID-Namen bewusst neutral gehalten (kein "ad", "banner", "sponsor").
 */
export default function PartnerSpot({ position }) {
  const [spots, setSpots] = useState([]);

  useEffect(() => {
    api.get(`/partner/public/${position}`)
      .then(r => setSpots(r.data || []))
      .catch(() => {});
  }, [position]);

  if (!spots.length) return null;

  return (
    <div className="music-partner-area my-6">
      {spots.map(spot => (
        <a
          key={spot.id}
          href={spot.link_url}
          target="_blank"
          rel="noopener noreferrer"
          className="featured-partner-link group block relative overflow-hidden rounded-xl transition-all duration-300 hover:brightness-105 hover:scale-[1.01]"
          aria-label={spot.alt_text || "Partner"}
        >
          {/* Subtle label – looks like editorial content */}
          <span className="absolute top-2 left-2 z-10 text-[10px] font-semibold uppercase tracking-widest text-white/50 bg-black/40 px-2 py-0.5 rounded-full backdrop-blur-sm">
            Empfehlung
          </span>
          <img
            src={spot.image_url}
            alt={spot.alt_text || ""}
            className="w-full h-auto object-cover rounded-xl"
            loading="lazy"
          />
        </a>
      ))}
    </div>
  );
}
